import { render, staticRenderFns } from "./SupervisorSignature.vue?vue&type=template&id=68b09a1e&"
import script from "./SupervisorSignature.vue?vue&type=script&lang=js&"
export * from "./SupervisorSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports